import React, {Children, ComponentType, ReactNode, useMemo} from 'react';

const stickyStyles: React.CSSProperties = {
  position: 'fixed',
  bottom: 0,
  left: 0,
  width: '100%',
  zIndex: 99,
  backgroundColor: '#fff',
  borderTop: '0.5px solid #bec9c6',
  marginBottom: '-120px',
  paddingBottom: '20px',
};

type Props = {
  children?: ReactNode;
  Separator: ComponentType<React.HTMLAttributes<HTMLDivElement>>;
  sticky?: boolean;
};

export function SeparateChildren({children, Separator, sticky}: Props) {
  const component = useMemo(() => {
    if (children === null || children === undefined) {
      return null;
    }

    const childrenArray = Children.toArray(children);
    return childrenArray
      .filter(Boolean)
      .reduce<
        Array<ReactNode>
      >((r, n, idx) => (idx < childrenArray.length - 1 ? [...r, n, <Separator key={`separator-${idx}`} />] : [...r, n]), []);
  }, [Separator, children]);

  return (
    <section style={sticky ? stickyStyles : undefined}>{component}</section>
  );
}
